<script>
    import InternationalCases from './InternationalCases.svelte';
    import InternationalDeaths from './InternationalDeaths.svelte';

    export let casesData;
</script>

<div class="chart-group">
    <h2>Timeline</h2>
    <InternationalCases data={casesData}/>
    <InternationalDeaths/>
</div>
